var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"login\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6661 23H15.5205C10.5487 23 8.15243 21.0404 7.73812 16.6509C7.69333 16.1918 8.02926 15.7775 8.49956 15.7327C8.95866 15.6879 9.37298 16.0351 9.41777 16.4942C9.7425 20.0102 11.3998 21.3204 15.5317 21.3204H15.6773C20.2347 21.3204 21.8472 19.7079 21.8472 15.1504V7.84955C21.8472 3.29211 20.2347 1.67965 15.6773 1.67965H15.5317C11.3774 1.67965 9.7201 3.01217 9.41777 6.59542C9.36178 7.05452 8.98106 7.40165 8.49956 7.35686C8.02926 7.32326 7.69333 6.90895 7.72692 6.44985C8.10764 1.99318 10.5151 0 15.5205 0H15.6661C21.1641 0 23.5156 2.35151 23.5156 7.84955V15.1504C23.5156 20.6485 21.1641 23 15.6661 23Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2624 12.3396H0.839824C0.38072 12.3396 0 11.9588 0 11.4997C0 11.0406 0.38072 10.6599 0.839824 10.6599H15.2624C15.7215 10.6599 16.1022 11.0406 16.1022 11.4997C16.1022 11.9588 15.7327 12.3396 15.2624 12.3396Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.765 16.0912C12.5522 16.0912 12.3395 16.0128 12.1715 15.8448C11.8468 15.5201 11.8468 14.9826 12.1715 14.6579L15.3293 11.5001L12.1715 8.34237C11.8468 8.01763 11.8468 7.48015 12.1715 7.15541C12.4963 6.83068 13.0337 6.83068 13.3585 7.15541L17.1097 10.9066C17.4344 11.2314 17.4344 11.7689 17.1097 12.0936L13.3585 15.8448C13.1905 16.0128 12.9778 16.0912 12.765 16.0912Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.8ae3d89fb8ba82ca374dbd9827e7a1c7.svg";
export { ForwardRef as ReactComponent };